import type { Route } from "./+types/mentorship";
import Page from "../pages/Mentorship";
import { pageMeta } from "../lib/meta";
import { content } from "../lib/content";
import { legacy } from "../lib/legacy";
import { OG_IMAGE } from "../config/heroArt";

export async function loader() {
  const [items, services] = await Promise.all([legacy.testimonials(), content.mentorship()]);
  return { items, services };
}
export const meta = () => pageMeta({ title: "Mentorship | Gazar", description: "Principal Engineer and team mentor. Hands-on guidance on scalable systems, career growth, and leadership.", path: "/mentorship", image: OG_IMAGE.mentorship });
export default function R({ loaderData }: Route.ComponentProps) {
  return <Page items={loaderData.items} services={loaderData.services} />;
}
